import {inject, injectable} from 'inversify';

import type {IApiDataMapper} from '../../../ports/types';
import type {SubtenantExtensionConfigurationModel} from '../SubtenantExtensionConfiguration.model';
import type {SubtenantMapperJrpc} from './Subtenant.mapper.jrpc';

import {SubtenantExtensionConfigurationFactory} from '../SubtenantExtensionConfiguration.factory';

@injectable()
export class SubtenantExtensionConfigurationMapperJrpc
  implements
    IApiDataMapper<
      // @ts-expect-error it requires id field
      SubtenantExtensionConfigurationMapperJrpc.ApiData,
      SubtenantExtensionConfigurationModel.Props,
      SubtenantExtensionConfigurationModel
    >
{
  constructor(
    @inject(SubtenantExtensionConfigurationFactory)
    private readonly factory: SubtenantExtensionConfigurationFactory,
  ) {}

  mapDataToModel(
    apiData: SubtenantExtensionConfigurationMapperJrpc.ApiData,
  ): SubtenantExtensionConfigurationModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(
    apiData: SubtenantExtensionConfigurationMapperJrpc.ApiData,
  ): SubtenantExtensionConfigurationModel.Props {
    const config: SubtenantExtensionConfigurationModel.Props = {
      behavior: 'evergreen',
      id: '',
    };

    if (apiData.includes('by_default')) {
      return config;
    } else if (apiData.includes('external_request')) {
      config.behavior = 'by_external_request';

      return config;
    } else {
      config.behavior = 'custom';

      config.custom = {
        by_client: apiData.includes('client_request'),
        by_coach: apiData.includes('coach_request'),
        by_conference: apiData.includes('conference'),
        by_subgoal: apiData.includes('subgoal'),
      };

      return config;
    }
  }

  mapModelToApiData(
    model: SubtenantExtensionConfigurationModel,
  ): SubtenantExtensionConfigurationMapperJrpc.ApiData {
    const apiData: SubtenantExtensionConfigurationMapperJrpc.ApiData = [];

    if (model.behavior === 'evergreen') {
      apiData.push('by_default');
    } else if (model.behavior === 'by_external_request') {
      apiData.push('external_request');
    } else {
      if (model.custom?.by_coach) {
        apiData.push('coach_request');
      }

      if (model.custom?.by_client) {
        apiData.push('client_request');
      }

      if (model.custom?.by_conference) {
        apiData.push('conference');
      }

      if (model.custom?.by_subgoal) {
        apiData.push('subgoal');
      }
    }

    return apiData;
  }
}

export namespace SubtenantExtensionConfigurationMapperJrpc {
  export type ApiData = SubtenantMapperJrpc.ApiData['auto_restart_on'];
}
